import { InfoBlock } from "..";
import { HeroCarousel } from "..";
import { useMobile } from "shared/lib/hooks";
import styles from "./HeroSection.module.scss";

export const HeroSection = () => {
  const isMobile = useMobile("950px");
  return (
    <div className={styles.heroSection}>
      {isMobile ? (
        <>
          <div className={styles.heroSection__info}>
            <InfoBlock />
          </div>
          <div className={styles.heroSection__carousel}>
            <HeroCarousel />
          </div>
        </>
      ) : (
        <>
          <div className={styles.heroSection__carousel}>
            <HeroCarousel />
          </div>
          <div className={styles.heroSection__info}>
            <InfoBlock />
          </div>
        </>
      )}
    </div>
  );
};
